import React, { FunctionComponent, useState, useEffect } from "react";
import { Grid, Box, Card, CardContent, Stack, Typography, MenuItem, CardActions } from "@mui/material";
import { CustomBreadCrumbs, PageHeader, CustomInput, CustomSelect, CustomDatePicker, Button } from "../../components";
import { CustomTextArea } from "../../components/CustomTextArea";
import { RefundDetailForm } from "../../components/RefundDetailForm";
import { mdiHome } from "@mdi/js"
import { getAxios } from "../../utils/endpoints";

export const RefundDetail: FunctionComponent = (): JSX.Element => {

    return (
        <RefundDetailForm />
    )
}